import Persona, { getInitials, backgroundColors } from './Persona';

export { getInitials, backgroundColors };
export default Persona;
